import { render, staticRenderFns } from "./PageSobre.vue?vue&type=template&id=3cbd80d8&scoped=true&"
import script from "./PageSobre.vue?vue&type=script&lang=js&"
export * from "./PageSobre.vue?vue&type=script&lang=js&"
import style0 from "./PageSobre.vue?vue&type=style&index=0&id=3cbd80d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbd80d8",
  null
  
)

export default component.exports